module.exports = __webpack_public_path__ + "img/loading.eb4833d9.webp";